import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from '@reach/router';
import { Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import Button from '@components/Button';
import { signUpUrl, loginUrl } from '@helpers/urls';
import triangleIcon from '@icons/triangleIcon';
import menuDropdownIcon from '@icons/menuDropdownIcon';
import menuDropdownIconBlack from '@icons/menuDropdownIconBlack';
import NavCta from '../NavCta';
import * as styles from './style.module.scss';

const {
  navigationButtons__buttons,
  navigationButtons__select,
  navigationButtons__button,
  navigationButtons__selectLinks,
  navigationButtons__englishOnly,
  navigationButtons__link,
  navigationButtons__login,
  navigationButtons__ctaGreen,
  button,
} = styles;

const NavigationButtons = ({ greenButton, isMobileView=false, isSubMenuOpened=false, isScrolled=false}) => {
  const { originalPath, language, path } = useI18next();
  const { t } = useTranslation();
  const [isStreamPage, setIsStreamPage] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname;
      setIsStreamPage(path.startsWith('/resources/stream/'));
    }
  }, []);

  const isEnglishOnlyPage =
    path.startsWith('/us/') ||
    (path.startsWith('/guides/') && path.length > '/guides/'.length) ||
    (path.startsWith('/customers/') && path.length > '/customers/'.length) ||
    (path.startsWith('/blog/') &&
      path.length > '/blog/'.length &&
      !path.startsWith('/blog/all')) ||
    (path.startsWith('de/blog/') &&
      path.length > 'de/blog/'.length &&
      !path.includes('de/blog/all')) ||
    (path.startsWith('de/resources/playbooks/') &&
      path.length > 'de/resources/playbooks/'.length) ||
    (path.startsWith('/resources/playbooks/') &&
      path.length > '/resources/playbooks/'.length);

  const isWebVisitorsPage =
    path.includes('/solutions/web-visitor-tracking/') ||
    path.includes('/web-visitors/');
  const isIpEnrichPage = path.includes('/platform/features/ip-enrich-api');

  const pageLanguages = [{ name: 'English', shortname: 'en' }];

  if (!isEnglishOnlyPage) {
    pageLanguages.push({ name: 'Deutsch', shortname: 'de' });
  }

  const sortedLanguages = [
    ...new Set([
      pageLanguages.find((lng) => lng.shortname === language),
      ...pageLanguages,
    ]),
  ];

  let icon;
  if (isMobileView) {
    icon = menuDropdownIconBlack;
  } else if (isStreamPage) {
    icon = menuDropdownIcon;
  } else {
    icon = isSubMenuOpened || isScrolled ? menuDropdownIconBlack : menuDropdownIcon;
  }
  
  return (
    <div className={navigationButtons__buttons}>
      {isEnglishOnlyPage ? 
        <div className={navigationButtons__englishOnly}></div>
      : (
        <details className={navigationButtons__select}>
          <summary className={navigationButtons__button}>
            {sortedLanguages[0].name}
            {icon}
          </summary>

          <nav className={navigationButtons__selectLinks}>
            {[...sortedLanguages].map(({ name, shortname }) =>
              language === shortname ? (
                <span className={navigationButtons__link} key={shortname}>
                  {name}
                </span>
              ) : (
                <Link
                  to={originalPath}
                  language={shortname}
                  className={navigationButtons__link}
                  key={shortname}
                >
                  {name}
                </Link>
              )
            )}
          </nav>
        </details>
      )}

      <a
        href={loginUrl(language)}
        className={`${navigationButtons__link} ${navigationButtons__login}`}
      >
        {t('cta_login')}
      </a>

      <NavCta greenButton={greenButton} />
    </div>
  );
};

export default NavigationButtons;
